import ProfileModel from "@/models/profileModel";
import { mapActions, mapGetters } from "vuex";

export const profileInterpreterMixin = {
  data() {
    return {
      profileModel: new ProfileModel(),
    };
  },
  computed: {
    ...mapGetters(["getRouteName"]),
    fetchInterpreterProfile() {
      /** New Logic **/
      let profileObj = new ProfileModel();
      profileObj
        .fetch({
          url: this.$interpretersApiUrl + this.profileModel.getRoute("fetch"),
          headers: { Bearer: localStorage.getItem("jwt") },
        })
        .then((res) => {
          let result = res.response.data;
          this.profileModel = result.data;

          localStorage.setItem(
            "fmInterpreterId",
            this.profileModel.fm_interpreter_id
          );
          localStorage.setItem(
            "interpreterFirstName",
            this.profileModel.first_name
          );
          localStorage.setItem(
            "interpreterLastName",
            this.profileModel.surname
          );
          localStorage.setItem("interpreterAddress", this.profileModel.address);
          localStorage.setItem("interpreterSuburb", this.profileModel.suburb);
          localStorage.setItem(
            "interpreterPostCode",
            this.profileModel.postcode
          );
          localStorage.setItem("interpreterPhone", this.profileModel.phone);
          localStorage.setItem("interpreterMobile", this.profileModel.mobile);
          localStorage.setItem("interpreterEmail", this.profileModel.email);
          localStorage.setItem("itProjectId", "2");
          localStorage.setItem(
            "interpreterLanguages",
            this.profileModel.languages
          );
          localStorage.setItem(
            "interpreterId",
            this.profileModel.interpreter_id
          );
          this.updateProfile(this.profileModel);

          if (this.$route.query) {
            if (this.$route.query.redirect) {
              let redirectArray = this.$route.query.redirect.split("/");
              if (redirectArray) {
                let name = redirectArray[1];
                if (name.toLowerCase() == "booking") {
                  this.$router.push({ path: this.$route.query.redirect });
                  return;
                } else if (name.toLowerCase() == "clockon") {
                  this.$router.push({ path: this.$route.query.redirect });
                  return;
                }
              }
            }
          }

          this.$router.push({ path: "bookingconfirmedtoday" });
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  methods: {
    ...mapActions(["updateProfile"]),
  },
};
